// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { getConfig } from '../../../config';
import RteEditor from '../../utils/FormWidgets/RteEditor';
import ElementSelector from '../../utils/FormWidgets/ElementSelector';
import '../../../styles/containers/Parties.css';

const { batchWebURL } = getConfig();

class CityHappening {
  title = '';
  subtitle = '';
  text = '';
}

class State {
  isNew = true;
  tab = 'write';
  cityHappening = new CityHappening();
}

export default class CityHappeningForm extends React.Component {
  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { cityHappening } = this.props;
    if (cityHappening) {
      this.setState({ cityHappening, isNew: false });
    }
  }

  titleChange = ({ target }) => {
    this.setState(prevState => {
      const cityHappening = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.cityHappening,
        title: target.value,
      };
      return { cityHappening };
    });
  };

  subtitleChange = ({ target }) => {
    this.setState(prevState => {
      const cityHappening = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.cityHappening,
        subtitle: target.value,
      };
      return { cityHappening };
    });
  };

  descriptionChange = ({ target }) => {
    this.setState(prevState => {
      const cityHappening = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.cityHappening,
        text: target.value,
      };
      return { cityHappening };
    });
  };

  descriptionRTEChange = data => {
    console.log(data);
    this.setState(prevState => {
      const cityHappening = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.cityHappening,
        text: data,
      };
      return { cityHappening };
    });
  };

  addLink = (value, act) => {
    switch (act.action) {
      case 'select-option': {
        this.setState(prevState => {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          console.log(prevState.cityHappening.text);
          const cityHappening = {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            ...prevState.cityHappening,
            // @ts-ignore
            // eslint-disable-next-line max-len
            text: `${prevState.cityHappening.text}[${value.value.title}](${batchWebURL}/experiences/${value.value.id})`,
          };
          return { cityHappening };
        });
        break;
      }
      default: {
        break;
      }
    }
  };

  validate = () => {
    const { cityHappening } = this.state;
    return (
      cityHappening.title.trim().length > 0 &&
      cityHappening.text.trim().length > 0
    );
  };

  submitElement = addElse => {
    let { cityHappening } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { onSubmit, type } = this.props;
    cityHappening = {
      ...cityHappening,
      title: cityHappening.title.trim(),
      text: cityHappening.text.trim(),
    };
    if (type === 'articles') {
      cityHappening = {
        ...cityHappening,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        subtitle: undefined,
      };
    } else {
      cityHappening = {
        ...cityHappening,
        subtitle: cityHappening.subtitle.trim(),
      };
    }
    if (addElse) {
      this.setState({ cityHappening: new CityHappening() });
    }
    onSubmit(cityHappening, addElse, type);
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { type, getActivities } = this.props;
    const { cityHappening, isNew } = this.state;
    const text = isNew ? 'Create' : 'Edit';
    const buttonText = isNew ? 'Create' : 'Update';
    const enttity = type === 'happenings' ? 'Happening' : 'artical about place';
    return (
      <Fragment>
        <h4 className='modal-head'>{`${text} ${enttity}`}</h4>
        <FormGroup style={{ paddingLeft: '0px' }}>
          <ControlLabel>Title</ControlLabel>
          <FormControl
            onChange={this.titleChange}
            value={cityHappening.title}
          />
        </FormGroup>
        {type === 'happenings' && (
          <Fragment>
            <FormGroup style={{ paddingLeft: '0px' }}>
              <ControlLabel>Subtitle</ControlLabel>
              <FormControl
                onChange={this.subtitleChange}
                value={cityHappening.subtitle}
              />
            </FormGroup>
            <FormGroup style={{ paddingLeft: '0px' }}>
              <ControlLabel>Description</ControlLabel>
              <FormControl
                componentClass='textarea'
                style={{ height: '100px' }}
                onChange={this.descriptionChange}
                value={cityHappening.text}
              />
            </FormGroup>
          </Fragment>
        )}
        {type === 'articles' && (
          <Fragment>
            <FormGroup>
              <ControlLabel>Description</ControlLabel>
              <RteEditor
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                value={cityHappening.text}
                onChange={this.descriptionRTEChange}
              />
            </FormGroup>
            <ElementSelector
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              value={null}
              placeholder='Select Activity for Adding Link'
              onChange={this.addLink}
              options={getActivities()}
            />
          </Fragment>
        )}
        <button
          type='button'
          className='btn btn-primary pull-right'
          disabled={!this.validate()}
          style={{ marginTop: '25px', marginRight: '0px' }}
          onClick={() => this.submitElement(false)}
          aria-label='left Align'
        >
          {buttonText}
        </button>
        {isNew && (
          <button
            type='button'
            className='btn btn-def pull-right'
            disabled={!this.validate()}
            style={{ marginTop: '25px', marginRight: '15px' }}
            onClick={() => this.submitElement(true)}
            aria-label='left Align'
          >
            Create and add else
          </button>
        )}
      </Fragment>
    );
  }
}
